import ConnectionError from 'components/ConnectionError';

// Bare shell for the auth/onboard apps. The ceremony screens carry
// their own centered layout (CeremonyLayout) — no outer logo, no card,
// nothing to nest inside.

export default function BasicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col">
      <ConnectionError />
      <div className="flex flex-1 flex-col justify-center">{children}</div>
    </div>
  );
}
